import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import { useNavigationWithScroll } from '../utils/navigation';
import styles from './FAQPage.module.css';

const FAQPage = () => {
  const navigate = useNavigate();
  const { navigateToSection } = useNavigationWithScroll();
  const [openItems, setOpenItems] = useState(new Set());

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqData = [
    {
      id: 0,
      question: "Where do you get the data?",
      answer: "Compliant by Design, Grounded in Truth. At Vates Domus AI, we do not scrape MLS data. We respect the rules, bylaws, and intellectual property of the National Association of Realtors (NAR) and local boards. Our platform interfaces strictly through approved, official real estate data feeds. We use Realty.com as our broker of record, and they provide the MLS data. Your data—and your MLS standing—are 100% secure with us."
    },
    {
      id: 1,
      question: "What is this app and what does it do?",
      answer: "Vates Domus AI is a property search and AI CMA generation software that allows you to search properties, by text based query, map, address, MLS ID, Lising ID, and zip code. Once you have found your subject property you can create a CMA for that property with AI Intelligence based on comparables you choose.  Vates Domus AI also includes MLS GPT, select up to ten properties and chat with them using AI. "
    },
    {
      id: 2,
      question: "What is an AI credit?",
      answer: "Each subscription plan comes with a set number of AI credits, a credit is only used when you generate an AI CMA on the CMA page, you are free to explorer the app and run queries to explore maps and properties and neighborhoods as part of your subscription."
    },
    {
      id: 3,
      question: "What if you do not serve my area?",
      answer: "Email us a info@vatesdomus.com, we will add your MLS board, this typically takes 1-2 weeks."
    },
    {
      id: 4,
      question: "How do I create an account?",
      answer: "Sign up is fast and simple, your realtor id will be required as this product is only allowed to be used by Real Estate agents and Brokers.  Simply enter your details and provide a credit card.  We use Stripe as our credit card processor, so we never save any credit card information."
    },
    {
      id: 5,
      question: "Is the app free to use?",
      answer: "Unfortunately there is no free tier."
    },
    {
      id: 6,
      question: "Can I use the app offline?",
      answer: "The product is designed and only runs using cloud connected services so there is no offline version."
    },
    {
      id: 7,
      question: "Does the app support multiple languages?",
      answer: "Yes! Our app is available to receive queries in multiple languages to cater to a diverse user base. In the MLS chat simply enter your query in your language of choice and submit."
    },
    {
      id: 8,
      question: "I forgot my password what should I do?",
      answer: "No worries! On the login screen, select \"Forgot Password?\" and enter your registered email address. We'll send you a password reset link. Follow the instructions to create a new password and regain access to your account."
    },
    {
      id: 9,
      question: "How do I update my account information?",
      answer: "Navigate to \u201cDashboard\u201d within the app, where you can update your email, phone number, and personal details. Remember to save your changes before exiting the settings menu."
    },
    {
      id: 10,
      question: "Is my data secure?",
      answer: "We take your privacy and data security seriously. All information is protected with end-to-end encryption, and our servers comply with the latest security standards. We never share your personal data with third parties without your explicit consent.  Furthermore we do not store credit card information either, we use a third party provider for subscriptions, Stripe. "
    },
    {
      id: 11,
      question: "How do I delete my account?",
      answer: "If you wish to delete your account, go to \u201cDashboard\u201d and select \u201cDelete Account.\u201d Follow the prompts to confirm your choice. Please note that deleting your account is permanent and cannot be undone. All your data will be removed from our servers in accordance with our data retention policy."
    },
    {
      id: 12,
      question: "How do I subscribe to premium features?",
      answer: "Al premium features are available to every tier of subscription. "
    },
    {
      id: 13,
      question: "Can I cancel my subscription?",
      answer: "Yes, you may cancel your subscription at any time."
    },
    {
      id: 14,
      question: "What payment methods are accepted?",
      answer: "We accept a variety of payment methods, through Stripe. More details can be found in the payment section when selecting or upgrading your plan."
    },
    {
      id: 15,
      question: "Will my subscription auto-renew?",
      answer: "Yes, subscriptions are automatically renewed at the end of each billing cycle to ensure uninterrupted access to premium features. You can disable auto-renewal in your app store's subscription management page."
    },
    {
      id: 16,
      question: "Do you offer refunds?",
      answer: "While you can cancel your subscription at any time, please note that we cannot offer refunds once you begin using our AI services. Why? The moment you start using the service, we incur immediate costs for AI, Cloud processing and data. Because these resources are allocated to you instantly, we are unable to recover them. By subscribing, you acknowledge and agree to this policy. We appreciate your understanding!"
    },
    {
      id: 17,
      question: "The app is crashing or not responding. What should I do?",
      answer: "If you experience technical issues, try refreshing the browser.  If the problem persists, contact our support team via the \u201cContact\u201d section in the app. Providing screenshots or error messages helps us resolve your issue faster.  Yoo can also email us at info@vatesdomus.com. "
    },
    {
      id: 18,
      question: "How do I provide feedback or request new features?",
      answer: "We value your feedback! Use the thumbs down or thumbs up button within the app or submit suggestions through our website. Your input helps us shape future updates and bring you the features you want most."
    },
    {
      id: 19,
      question: "How often is the app updated?",
      answer: "We regularly release updates to introduce new features, improve performance, and enhance security."
    },
    {
      id: 20,
      question: "Which devices and operating systems does the app support?",
      answer: "Currently the app requires an internet connected browser of your choice, the app was designed for use with Google Chrome, so you may experience the best results using Chrome."
    },
    {
      id: 21,
      question: "Can I invite friends or colleagues to join my workspace?",
      answer: "No, your workspace is private to you."
    },
    {
      id: 22,
      question: "Where can I find tutorials or guides?",
      answer: "Comprehensive tutorials and user guides are in the \u201cFAQ\u201d section of the app and on our website. Video walkthroughs and FAQs are also available to assist you in mastering the app\u2019s features. Also, when you are logged in you can interact with the FAQ Assistant, it is trained on this FAQ and the demo videos."
    },
    {
      id: 23,
      question: "What if my question isn't answered here?",
      answer: "If you didn\u2019t find what you were looking for, please reach out to our support team at info@vatesdomus.com."
    },
    {
      id: 24,
      question: "What is MLS GPT?",
      answer: "MLS GPT allows you to search for a range of properties using zip code or map search, once you have a list of candidate properties you can select up to ten and ask questions and have discussions using AI.  You can ask things like summarize these properties for a potential buyer email.  Ask questions about the area the properties are located in. For cities that have subway or public transit lines you can even ask which subway lines serve this neighborhood. You can also ask AI to highlight regional events and amenities in the neighborhood, as well as help you write a property description.  You can also select a property and see a brief property card and generate an AI CMA."
    },
    {
      id: 25,
      question: "What is MLS Chat?",
      answer: "MLS Chat is yet another way to search for properties using natural language.  Simply enter a natural language query such as \u201cShow me properties in Asheville, NC that are between 3 and 5 bedrooms, at least 2250 sqft and less than $999,000\u201d and click submit, from there you can display a property card by selecting the MLS id or the Listing ID.  You can also create an AI generated CMA."
    },
    {
      id: 26,
      question: "What is the AI Generated CMA?",
      answer: "The AI CMA Analysis is a comprehensive report that includes Listing Info, Property Tax information, Average Mortgage rates for the subject state, interactive Property Location map, Scatter plot for active and sold homes, Active/Pending/Sold comparables that are the same property type, within 20% sqft of the subject property and within an up to 13 mile radius of the subject property, you choose the properties you want to compare the subject property to.  The AI Analysis can be run after the Agent has selected the comparables.  The AI CMA also includes Property Overview and Market Position, Price analysis of the subject and all of the comparables, Property Characteristics Comparison, Market Trends and Timing, Location Analysis, Competitive Advantages/Disadvantages, Recommendations, Risk Factors. "
    }
  ];

  const toggleItem = (id) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  const scrollToContact = () => {
    navigate('/contact');
  };

  return (
    <PublicLayout>
      <div className={styles.faqPage}>

      {/* Main Content */}
      <div className={styles.faqContainer}>
        <div className={styles.faqContent}>
          <div className={styles.faqHeaderSection}>
            <h1>Vates Domus AI</h1>
            <h2>Frequently Asked Questions (FAQ)</h2>
            <p className={styles.faqSubtitle}>Your guide to a seamless experience</p>
          </div>

          <div className={styles.faqList}>
            {faqData.map((item) => (
              <div 
                key={item.id} 
                className={`${styles.faqItem} ${openItems.has(item.id) ? styles.open : ''}`}
              >
                <button 
                  className={styles.faqQuestion}
                  onClick={() => toggleItem(item.id)}
                >
                  <span>{item.question}</span>
                  <span className={styles.faqArrow}>
                    {openItems.has(item.id) ? '▼' : '▶'}
                  </span>
                </button>
                <div className={styles.faqAnswer}>
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.faqFooter}>
            <p>Still have questions?</p>
            <button 
              className={styles.contactSupportBtn}
              onClick={scrollToContact}
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
    </div>
    </PublicLayout>
  );
};

export default FAQPage;
